// Titles and summaries come from the user's own live sessions and are rendered
// as text only, never injected as HTML.

import { isNumber, isString } from "../utils/schemaUtils";

export interface LiveSessionSearchHit {
  id: string;
  title: string;
  summary: string;
  // RFC 3339 timestamp.
  createdAt: string;
}

export interface LiveSessionSearchResultsPayload {
  type: "live_session_search_results";
  version: number;
  toolId: string;
  query: string;
  hits: LiveSessionSearchHit[];
  userError?: string;
}

const isHit = (v: unknown): v is LiveSessionSearchHit => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return isString(r.id) && isString(r.title) && isString(r.summary) && isString(r.createdAt);
};

export const parseLiveSessionSearchResultsPayload = (v: unknown): LiveSessionSearchResultsPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "live_session_search_results") return null;
  if (!isNumber(r.version)) return null;
  if (!isString(r.toolId)) return null;
  if (!isString(r.query)) return null;
  if (!Array.isArray(r.hits) || !r.hits.every(isHit)) return null;
  if (r.userError !== undefined && !isString(r.userError)) return null;
  return {
    type: "live_session_search_results",
    version: r.version,
    toolId: r.toolId,
    query: r.query,
    hits: r.hits,
    userError: r.userError,
  };
};
